import React from 'react';
import { Rect } from 'flow/utils/meeting-layout';

interface PositionedTileProps {
    rect: Rect;
    children: React.ReactNode;
}

/** Absolutely-positioned wrapper at `rect`; the child fills it. */
const PositionedTile: React.FC<PositionedTileProps> = ({ rect, children }) => (
    <div
        className="absolute"
        style={{
            // Logical inline-start (not `left`) so the whole engine-computed
            // grid mirrors in RTL — `x` is measured from the start edge.
            insetInlineStart: rect.x,
            top: rect.y,
            width: rect.width,
            height: rect.height,
        }}
    >
        {children}
    </div>
);

export default PositionedTile;
